import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconArMobile$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconArMobile extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a4fb18054871943d4c178bb75b4af91c54ef2874', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'c9bbb745e78918ca3659138a91e7472911ac4c09', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd32072ed559d31b2c6149fbbb6bc82450987b8e5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.3 12h1.37a.3.3 0 0 0 .24-.47l-1.44-2.07a.25.25 0 0 0-.47.15v2.09a.29.29 0 0 0 .3.3M12 8.3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-4.5 7.2v-11h7v3L12 11l-.91-1.31a.29.29 0 0 0-.49 0l-1.27 1.83a.3.3 0 0 0 .24.47h4.93v3.5zM2.34 12H3.7a.29.29 0 0 0 .3-.3V9.61a.25.25 0 0 0-.47-.15l-1.44 2.07a.3.3 0 0 0 .25.47m4.16 5h9a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-ar-mobile", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-ar-mobile"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-ar-mobile":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconArMobile$1);
            }
            break;
    } });
}

const CosmosIconArMobile = CosmosIconArMobile$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconArMobile, defineCustomElement };
